/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNumber } from '../../factoriesAny.js';
export var numberDependencies = {
  typedDependencies,
  createNumber
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesNumber.generated.js
// module id = 132
// module chunks = 2